import React from 'react';

import { useMarketingFooterColumns } from './footerColumns';

// `columns` defaults to the site footer for the current release mode.
function MarketingFooter({
  logo,
  brandHref = '/',
  brandCopy,
  columns: columnsOverride,
  bottomText,
}) {
  const releaseColumns = useMarketingFooterColumns();
  const columns = columnsOverride || releaseColumns;

  return (
    <footer>
      <div className="container">
        <div className={`fcols${columns.length > 2 ? ' fcols-wide' : ''}`}>
          <div className="brand-col">
            <a href={brandHref} className="logo">
              {logo}
            </a>
            {brandCopy && <p>{brandCopy}</p>}
          </div>
          {columns.map((column) => (
            <div key={column.title}>
              <h4>{column.title}</h4>
              <ul>
                {column.links.map((link) => (
                  <li key={`${column.title}-${link.label}`}>
                    <a href={link.href}>{link.label}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="footer-bottom">
          <span>{bottomText}</span>
        </div>
      </div>
    </footer>
  );
}

export default MarketingFooter;
